import { render, staticRenderFns } from "./portfolioListElement.vue?vue&type=template&id=62f7264a&scoped=true"
import script from "./portfolioListElement.vue?vue&type=script&lang=js"
export * from "./portfolioListElement.vue?vue&type=script&lang=js"
import style0 from "./portfolioListElement.vue?vue&type=style&index=0&id=62f7264a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f7264a",
  null
  
)

export default component.exports